import { render, staticRenderFns } from "./GiveaWardKu.vue?vue&type=template&id=6355dfba&"
import script from "./GiveaWardKu.vue?vue&type=script&lang=js&"
export * from "./GiveaWardKu.vue?vue&type=script&lang=js&"
import style0 from "./GiveaWardKu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports